import { Routes } from '@angular/router';

import { CommonComponent } from '@components/auth/common/common.component';
import { ROUTE_PATH } from '@shared/enum/common.enum';
import { loginGuard } from '@shared/guard/login.guard';
import { otpGuard } from '@shared/guard/otp.guard';
import { resetPasswordGuard } from '../guard/resetpassword.guard';
import { selectGuard } from '../guard/select-role.guard';

export const authRoutes: Routes = [
    {
        path: '',
        redirectTo: ROUTE_PATH.LOGIN,
        pathMatch: 'full',
    },

    {
        path: '',
        component: CommonComponent,
        children: [
            {
                path: ROUTE_PATH.LOGIN,
                canActivate: [loginGuard],
                loadComponent: () =>
                    import('@components/auth/login/login.component').then(
                        (m) => m.LoginComponent
                    ),
            },
            {
                path: ROUTE_PATH.OTP,
                canActivate: [otpGuard],
                loadComponent: () =>
                    import('@components/auth/otp/otp.component').then(
                        (m) => m.OtpComponent
                    ),
            },
            {
                path: ROUTE_PATH.FORGOT_PASSWORD,
                canActivate: [loginGuard],
                loadComponent: () =>
                    import(
                        '@components/auth/forgot-password/forgot-password.component'
                    ).then((m) => m.ForgotPasswordComponent),
            },
            {
                path: ROUTE_PATH.RESET_PASSWORD,
                canActivate: [resetPasswordGuard],
                loadComponent: () =>
                    import(
                        '@components/auth/reset-password/reset-password.component'
                    ).then((m) => m.ResetPasswordComponent),
            },
            {
                path: ROUTE_PATH.SELECT_ROLE,
                canActivate: [selectGuard],
                loadComponent: () =>
                    import(
                        '@components/auth/select-role/select-role.component'
                    ).then((m) => m.SelectRoleComponent),
            },
        ],
    },
];
